import Button from '@mui/material/Button';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import Icon from '/@/components/icon';
import Popup from '/@/components/popup';
import { _ } from '/@/locale';
import { isMobile } from '/@/utils';
import Title from '/@/v3/components/title';
import styles from './styles.module.css';

@connect((state, props) => {
    return {
        isMobile: isMobile(),
    };
})
@autobind
export default class PopupSendStatus extends Component {
    static propTypes = {
        onClose: PropTypes.func,
        visible: PropTypes.bool,
        error: PropTypes.bool,
        reSendPost: PropTypes.func,
        showCloseIcon: PropTypes.bool,
    };

    render() {
        const { error, visible, onClose, reSendPost, showCloseIcon, isMobile } = this.props;
        const title = error ? 'No pudimos enviar tu consulta' : 'Tu consulta se envió correctamente';
        const subtitle = error
            ? 'Hubo un error interno'
            : '¡Un técnico te responderá por mail a la brevedad!\n\nRecordá revisar el correo no deseado.';
        const icon = error ? (
            <Icon type='notSent' size={isMobile ? 'lg' : 'xl'} />
        ) : (
            <Icon type='sent' size={isMobile ? 'md' : 'xl'} />
        );
        const classTitle = error ? styles.titleModalError : styles.titleModal;
        return (
            <Popup visible={visible} onClose={onClose} showCloseIcon={showCloseIcon}>
                <div className={styles.root}>
                    <div>{icon}</div>
                    <div className={classTitle}>
                        <Title align='center' bolder size={isMobile ? 'lg' : 'xl'}>
                            {_(title)}
                        </Title>
                    </div>
                    <div>
                        <Title align='center' size={isMobile ? 'xs' : 'md'}>
                            {_(subtitle)}
                        </Title>
                    </div>
                    {this.props.error && (
                        <div className={styles.reSendPost}>
                            <Button size={isMobile ? 'small' : 'medium'} onClick={reSendPost} variant='text'>
                                {_('Volver a intentar')}
                            </Button>
                        </div>
                    )}
                </div>
            </Popup>
        );
    }
}
